enum FormTypeName {
  AddForm = 'add',
  EditForm = 'edit'
}

export default FormTypeName;
